import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import {AnimationBuilder, AnimationService} from "css-animator";

@Injectable()
export class SmartanimationProvider {

  public animation:AnimationBuilder;
  constructor(public http: Http,public animationService:AnimationService) {
    console.log('Hello SmartanimationProvider Provider');
  }
  smartAnimation(){
   this.animation=this.animationService.builder();
   return this.animation;
  }

}



// WEBPACK FOOTER //
// ./src/providers/smartanimation/smartanimation.ts